import { useEffect } from 'react';
import {
    TwitterShareButton,
    TwitterIcon,
} from 'next-share';

export const TwitterShareTemplate = ({ pageUrl, pageTitle }) => {
    useEffect(() => {
        // Add `rel="nofollow"` to the first anchor tag in this component
        const shareLinks = document.querySelectorAll('.twitter-share-button button');
        shareLinks.forEach((link) => {
            link.setAttribute('rel', 'nofollow');
        });
    }, []);
    return (
        <div className="twitter-share-button">
            <TwitterShareButton
                url={`${pageUrl}`}
                quote={pageTitle}
                title={`${pageTitle}`}
            >
                <TwitterIcon size={44} round />
            </TwitterShareButton>
        </div>
    );
}
